import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface RevokePersonalAccessTokenParams {
    refreshToken: string;
}

export interface RevokePersonalAccessTokenResult  extends IResult {
}

export class RevokePersonalAccessTokenRequest extends Request<RevokePersonalAccessTokenParams, RevokePersonalAccessTokenResult> {
  constructor(params: RevokePersonalAccessTokenParams) {
    super('revokePersonalAccessToken', params);
  }
}
